// @ts-nocheck
import React from "react";
import { QuerySelect } from "components/Inputs/CustomAsyncSelect/CustomAsyncSelect";
import genRequest from "includes/request";
import { t } from "i18next";

export const getAssignTypes = () => [
	{
		value: "companies",
		label: t("Companies.COMPANIES"),
		itemId: "companyId",
		component: CompaniesAssignRow,
		uniqueIfMultiple: true,
		minRole: "EloAdmin",
	},
	{
		value: "sites",
		label: t("Sites.SITES"),
		itemId: "siteId",
		component: SitesAssignRow,
	},
	{
		value: "groups",
		label: t("Groups.GROUPS"),
		itemId: "groupId",
		component: GroupsAssignRow,
	},
	{
		value: "wfams",
		label: t("WorkFamilies.WORK_FAMILLIES"),
		itemId: "workFamilyId",
		maxItems: 10, // max number of selected items
		limitItemsAfterLevel: 2, // limit max items after certain deppLevel
		component: WFamsAssignRow,
	},
];

function CompaniesAssignRow(props) {
	const { type, item } = props;
	let maxLimit =
		type.maxItems &&
		(!type.limitItemsAfterLevel ||
			item.deepLevel > type.limitItemsAfterLevel)
			? type.maxItems
			: false;

	return (
		<QuerySelect
			all={
				maxLimit === false
					? {
							value: "ALL",
							label: t("Companies.ALL_COMPANIES"),
					  }
					: false
			}
			className="assign-drop w-100"
			queryKey={["Companies"]}
			queryFn={() => genRequest("companies")}
			closeMenuOnSelect={false}
			treat={(a) => {
				return {
					label: a.name,
					value: a.id,
					companyId: a.id,
				};
			}}
			max={maxLimit}
			onChange={props?.onChange}
			isMulti={true}
			initialValue={props?.initialValue}
		/>
	);
}

function SitesAssignRow(props) {
	const { companyId, type, item } = props;
	let maxLimit =
		type.maxItems &&
		(!type.limitItemsAfterLevel ||
			item.deepLevel > type.limitItemsAfterLevel)
			? type.maxItems
			: false;

	return (
		<QuerySelect
			all={
				maxLimit === false
					? {
							value: "ALL",
							label: t("Commons.ALL_SITES"),
					  }
					: false
			}
			className="assign-drop w-100"
			queryKey={["Sites", "SitesOfCompany", companyId]}
			queryFn={() => genRequest("sites/company/" + companyId)}
			closeMenuOnSelect={false}
			treat={(a) => {
				return {
					label: a.name + (a.address ? " - " + a.address : ""),
					value: a.id,
					companyId: a.companyId,
				};
			}}
			max={maxLimit}
			onChange={props?.onChange}
			isMulti={true}
			initialValue={props?.initialValue}
		/>
	);
}

function GroupsAssignRow(props) {
	const { companyId, type, item } = props;
	let maxLimit =
		type.maxItems &&
		(!type.limitItemsAfterLevel ||
			item.deepLevel > type.limitItemsAfterLevel)
			? type.maxItems
			: false;

	return (
		<QuerySelect
			all={
				maxLimit === false
					? {
							value: "ALL",
							label: t("Groups.ALL_GROUPS"),
					  }
					: false
			}
			className="assign-drop w-100"
			queryKey={["Groups", "OfCompany", companyId]}
			queryFn={() => genRequest("groups/company/" + companyId)}
			closeMenuOnSelect={false}
			treat={(a) => {
				return {
					label: a.groupName,
					value: a.id,
					companyId,
				};
			}}
			max={maxLimit}
			onChange={props?.onChange}
			isMulti={true}
			initialValue={props?.initialValue}
		/>
	);
}

function WFamsAssignRow(props) {
	const { companyId, type, item } = props;

	let maxLimit =
		type.maxItems &&
		(!type.limitItemsAfterLevel ||
			item.deepLevel > type.limitItemsAfterLevel)
			? type.maxItems
			: false;
	return (
		<QuerySelect
			all={
				maxLimit === false
					? {
							value: "ALL",
							label: t("WorkFamilies.ALL_FAMS"),
					  }
					: false
			}
			className="assign-drop w-100"
			queryKey={["WorkFamilies", "WorkFamilyOfCompany", companyId]}
			queryFn={() =>
				genRequest("work-families/company/" + companyId)
			}
			closeMenuOnSelect={false}
			treat={(a) => {
				return {
					label: a.name,
					value: a.id,
					companyId,
				};
			}}
			max={maxLimit}
			onChange={props?.onChange}
			isMulti={true}
			initialValue={props?.initialValue}
		/>
	);
}

export function getNextTypes(curType, isSup) {
	let AssignTypes = getAssignTypes();
	let type = curType ? curType : AssignTypes[0].value;

	let index = AssignTypes.findIndex((a) => a.value === type);

	if (index === -1) return false;

	let items = AssignTypes.slice(index, AssignTypes.length);
	let nexts = items
		.map((a) => {
			if (!isSup || isSup(a.minRole) >= 0) return a;
			return false;
		})
		.filter((a) => a);
	return nexts;
}
